/* eslint-disable camelcase */

export const constants = {
  POST_SERVICE_COMPANY_ORDER: 'POST_SERVICE_COMPANY_ORDER',
  POST_SERVICE_COMPANY_ORDER_SUCCESS: 'POST_SERVICE_COMPANY_ORDER_SUCCESS',
  POST_SERVICE_COMPANY_ORDER_FAIL: 'POST_SERVICE_COMPANY_ORDER_FAIL',
  RESET_SERVICE_COMPANY_ORDER: 'RESET_SERVICE_COMPANY_ORDER',
};

export const services = {
  postServiceCompanyOrder: (data) => ({
    route: `/api/v2/lines/${data.lineId}/services/${data.serviceSlug}/order`,
    method: 'post',
    body: data,
  }),
};
